import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const ChartTagText = styled.span`
    font-family: 'Poppins', sans-serif;
    color: #8B8C99;
    font-size: 14px;
    line-height: 35px;
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 14px;
    }
`;

export const ChartTagMark = styled.span`
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    border-radius: 50%;
    margin-right:  ${({ marginRight }) => marginRight};
    background-color: ${({ color }) => color};
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        width: 24px;
        height: 24px;
        margin-right: 12px;
    }
`;
